export const MLRControlGroupLabelId = (id: string) => {
  return `${id}-label`;
};

export const MLRControlGroupId = (id: string) => {
  return `${id}-group`;
};

export const MLRControlGroupSelector = (id: string) => {
  return `#${MLRControlGroupId(id)}`;
};

export const SLRControlGroupId = (id: string) => {
  return `${id}-group`;
};
